var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'silver-app': true, 'page-shell': _vm.isSpecialPage },attrs:{"id":"app"}},[_c('router-view',{on:{"changeLanguage":_vm.changeLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }